var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"method-row\">\n<div ng-cloak class=\"method\" ng-repeat=\"b in $ctrl.auth_methods | orderBy:'name' track by b.auth_id\" ng-click=\"$ctrl.startLoginFlow(b)\" role=\"button\" aria-label=\"{{ b.name }}\">\n<img class=\"method-button\" ng-attr-title=\"{{ b.name }}\" ng-attr-alt=\"{{ b.name }}\" ng-src=\"{{ b.logo_url }}\"/>\n</div>\n<div class=\"col-xs-12 spinner-wrapper\" ng-if=\"$ctrl.loading\">\n<p class=\"text-center\">\n<span us-spinner></span>\n</p>\n</div>\n</div>\n";
var id1="app/auth_method/auth_method.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/auth_method/auth_method.tpl.html
// module id = 379
// module chunks = 6